var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0C8.795 0 5.78133 1.24833 3.51467 3.51467L1.33333 5.696V1.33333C1.33333 0.965333 1.03467 0.666667 0.666667 0.666667C0.298667 0.666667 0 0.965333 0 1.33333V7.33333C0 7.70133 0.298667 8 0.666667 8H6.66667C7.03467 8 7.33333 7.70133 7.33333 7.33333C7.33333 6.96533 7.03467 6.66667 6.66667 6.66667H2.24833L4.45733 4.45767C6.47233 2.443 9.151 1.33333 12 1.33333C17.8817 1.33333 22.6667 6.11833 22.6667 12C22.6667 17.8817 17.8817 22.6667 12 22.6667C6.11833 22.6667 1.33333 17.8817 1.33333 12C1.33333 11.632 1.03467 11.3333 0.666667 11.3333C0.298667 11.3333 0 11.632 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0Z",
    fill: "#1B67AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3335 16C15.1628 16 14.9925 15.935 14.8622 15.8047L11.5288 12.4713C11.4038 12.3463 11.3335 12.1767 11.3335 12V4.66667C11.3335 4.29867 11.6322 4 12.0002 4C12.3682 4 12.6668 4.29867 12.6668 4.66667V11.7237L15.8048 14.862C16.0652 15.1223 16.0652 15.5443 15.8048 15.8047C15.6745 15.935 15.5042 16 15.3335 16Z",
    fill: "#1B67AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockTurn);
export default __webpack_public_path__ + "static/media/clock-turn.a11b05ba220ed5c7dd96b3a4141e8208.svg";
export { ForwardRef as ReactComponent };